// extracted by mini-css-extract-plugin
export default {"createAppointmentButton":"CreateAppointmentButton_createAppointmentButton__xEZO0"};